import React from 'react';
import { useCurrencyFormat } from 'src/core/hooks/format';
import { useCurrencyContext } from './CurrencyProvider';

interface CurrencyProps {
    amount: number;
    currencyIso?: string;
}

const Currency: React.FC<CurrencyProps> = ({ amount, currencyIso }) => {
    const formatCurrency = useCurrency(currencyIso);

    return <>{formatCurrency(amount)}</>;
};

export default Currency;

export function useCurrency(currencyIso?: string) {
    const _currencyIso = useCurrencyContext().currencyIso;

    const formatCurrency = useCurrencyFormat()({
        currency: currencyIso ?? _currencyIso,
    });

    return formatCurrency;
}
